//* 화환 스토어 명절 연휴 안내 — 기간은 KST 시각 기준(양끝 포함), 지나면 자동으로 꺼진다.
//* 명절마다 아래 두 시각만 바꾸면 되고, 문구·노출 위치는 손대지 않는다.
//* 시작이 전날 저녁인 이유: 20시 이후 주문은 익일 배송이라 그 시점부터 연휴 배송 조건이 적용된다.
//* 노출 위치: 메인 전화박스·체크아웃 전화박스(단축운영), 상품상세 도착보장 아래·구매 배송 안내(당일중배송)
export const HOLIDAY_NOTICE_FROM = '2026-09-23T19:00:00+09:00';
export const HOLIDAY_NOTICE_TO = '2026-09-26T23:59:59+09:00';

/** 배지 라벨 — 명절 이름만 바꿔 쓴다 (설 연휴 / 추석 연휴) */
export const HOLIDAY_NOTICE_LABEL = '추석 연휴';

/** 고객센터 단축 운영 시간 표기 */
export const HOLIDAY_CALL_CENTER_HOURS = '10:00~18:00';

const FROM_MS = new Date(HOLIDAY_NOTICE_FROM).getTime();
const TO_MS = new Date(HOLIDAY_NOTICE_TO).getTime();

/** 지금(브라우저 시계)이 명절 안내 기간인지 — 절대시각 비교라 브라우저 시간대와 무관 */
export const isHolidayNoticePeriod = (now: Date = new Date()) => {
  const t = now.getTime();
  return t >= FROM_MS && t <= TO_MS;
};
